module.exports = __webpack_public_path__ + "static/media/chevron_up.f9c6fba1.svg";